import angular from 'angular';
import oclazyload from 'oclazyload';
// eslint-disable-next-line import/no-cycle
import Modules from './modulesService';

/**
 * @module "7Shop.Modules"
 */
const moduleName = angular.module('7Shop.Modules', [oclazyload])
  .service('Modules', Modules)
  .name;

export default moduleName;
